import React from "react";
import FaqContent from "../FunctionalComponents/FAQ/FaqContent";

function FAQ() {
  return (
    <>
      <FaqContent />
    </>
  );
}

export default FAQ;
